export default (that) => [
  {
    text: that.$l('btn_cancel_create_subtasks') || '创建子任务',
    icon: 'el-icon-plus',
    menuType: 'create',
    allow: 'A',
    disabled: ({ parentTskCode }) => !!parentTskCode || !that.isCreateChild,
  },
  {
    text: that.$l('btn_cancel_task') || '任务取消',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ tskStatus }) =>
      ['D', 'Y'].includes(tskStatus) || !that.isCancal,
  },
]
